"use strict";

let connectionID;
let num;
(function (window, EWS) {
    let connection;
    let returnConnection = [];
    window.getGlobalConnection = function () {
        if (connection) {
            return Promise.resolve(connection);
        }
        return new Promise((resolve) => {
            returnConnection.push(resolve);
        });
    };
    async function browserNotify(userName, message, callback) {
        if (!("Notification" in window)) {
            return;
        }
        if (Notification.permission === "denied") {
            return;
        }
        if (Notification.permission === "default") {
            await Notification.requestPermission().catch(err => "denied");
        }
        if (Notification.permission !== "granted") {
            return;
        }
        if (!message) {
            return;
        }
        if (!document.hidden) {
            return;
        }
        // eslint-disable-next-line no-new
        const notify = new Notification(`来自${userName}的消息`, {
            body: message
        });
        notify.onclick = function (e) {
            e.preventDefault();
            window.focus();
            if (typeof callback === "function") {
                callback();
            }
            return false;
        };
    }
    browserNotify("系统消息", null);
    window.browserNotify = browserNotify;
    EWS.Ready(async () => {
        function getConnection() {
            const options = { skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets };

            return new signalR.HubConnectionBuilder()
                .withUrl(`${window.location.origin}/hubs/chathub`, options)
                .configureLogging(signalR.LogLevel.Information)
                .withAutomaticReconnect()
                .build();
        }

        const jsPromises = [
            EC_Fmt.LoadScript("https://cdnjs.cloudflare.com/ajax/libs/microsoft-signalr/6.0.1/signalr.js")
        ];
        if (jsPromises) {
            await Promise.all(jsPromises);
        }

        connection = getConnection();

        connection.on("ReceiveConnectionId", (connID) => {
            connectionID = connID;
            if (returnConnection) {
                returnConnection.forEach(a => a(connection));
                returnConnection = [];
            }
        });

        connection.on("ReceiveGroupMessage", (msg) => {
            const NotificationNumEle = document.getElementById("NotificationNum");
            if (NotificationNumEle) {
                NotificationNumEle.style.display = "block";
                let notificationNum = Number(localStorage.getItem("notificationNum"));
                if (notificationNum === 0) {
                    notificationNum = 1;
                } else {
                    notificationNum++;
                }
                NotificationNumEle.innerText = notificationNum;
                localStorage.setItem("notificationNum", Number(notificationNum));
            }
        });
        connection.on("connectionStateChanged", async (state) => {
            if (state !== signalR.HubConnectionState.Connected) {
                await connection.start();
            }
        });

        connection.onclose(async () => {
            await connection.start();
        });

        await connection.start();
        connection.invoke("JoinGroup", Distributor);
        const NotifyButton = document.getElementById("NotifyButton");

        if (NotifyButton) {
            NotifyButton.onclick = () => {
                const NotificationNumEle = document.getElementById("NotificationNum");
                if (NotificationNumEle) {
                    NotificationNumEle.style.display = "none";
                    NotificationNumEle.innerText = 0;
                    localStorage.removeItem("notificationNum");
                }
                window.location.href = `${window.location.origin}/Home?DashboardID=195849`;
            };

            const NotificationNumEle = document.getElementById("NotificationNum");
            const notificationNum = Number(localStorage.getItem("notificationNum"));
            if (notificationNum !== 0) {
                NotificationNumEle.innerText = notificationNum;
                NotificationNumEle.style.display = "block";
            }
        }
        const EduGoHome = document.getElementById("EduGoHome");
        if (EduGoHome) {
            EduGoHome.onclick = () => {
                window.location.href = `${window.location.origin}/Home?DashboardID=195762`;
            };
        }
    });
}(window, EWS));
